export class FromToDateModal{
    fromdate:Date;
    toDate:Date;
}